import toast from 'react-hot-toast';
import { takeEvery, put, call } from 'redux-saga/effects';
import * as adminApi from '../../api/adminApi';
import * as actions from '../actions';
import { push } from 'connected-react-router';

export function* getUsers() {
  try {
    const users = yield call(adminApi.getUsers);
    yield put(actions.admin.getUsersSuccess(users));
  } catch (e) {
    yield put(actions.admin.getUsersFail(e.message));
    toast.error('An error occurred loading users.');
  }
}
export function* addUser({ payload: { user } }) {
  try {
    const newUser = yield call(adminApi.addUser, user);
    yield put(actions.admin.addUserSuccess());
    yield put(actions.admin.getUsers());
    toast.success('User added.');
    yield put(push(`/admin/user/${newUser.id}`));
  } catch (e) {
    console.log(e);
    yield put(actions.admin.addUserFail());
    toast.error('An error occurred adding a new user.');
  }
}

export function* updateUser({ payload: { user } }) {
  try {
    yield put(actions.user.setLoading(true, 'Updating user...'));
    yield call(adminApi.updateUser, user);
    yield put(actions.admin.updateUserSuccess());
    yield put(actions.admin.getUsers());
  } catch (e) {
    yield put(actions.admin.updateUserFail());
    toast.error('An error occurred updating a user.');
  } finally {
    yield put(actions.user.setLoading(false));
  }
}

export function* setUser({ payload: { userId } }) {
  try {
    yield put(actions.admin.getUsers());
    yield put(actions.admin.setUserSuccess(userId));
  } catch (e) {
    toast.error('An error occurred retrieving the selected user.');
  }
}

export function* loadAdminData() {
  yield put(actions.admin.getUsers());
  yield put(actions.admin.getGroups());
  yield put(actions.admin.getSites());
}

export function* userSagas() {
  yield takeEvery(actions.admin.getUsers, getUsers);
  yield takeEvery(actions.admin.addUser, addUser);
  yield takeEvery(actions.admin.updateUser, updateUser);
  yield takeEvery(actions.admin.setUser, setUser);
  yield takeEvery(actions.admin.loadAdminData, loadAdminData);
}
